module.exports = __webpack_public_path__ + "static/media/main-image1.5732ed33.png";